import React from "react";
import "./About.css";
import ProfilePic from "../../Image/Ay.jpg";

const About = () => {
  return (
    <div className="container about-section" id="about">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div className="about-image-container">
            <div className="about-image-glow"></div>
            <img src={ProfilePic} alt="Olatunji Ayobami Samson" className="about-image" />
          </div>
        </div>

        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div className="about-details">
            <div className="about-title">
              <h2>About Me</h2>
              <span className="line"></span>
            </div>

            <p className="description">
              Hi, I'm Olatunji Ayobami Samson, a <strong>Senior Mobile Developer</strong> specializing in <strong>Flutter</strong> and modern mobile ecosystems. Over the years, I've evolved from crafting intuitive frontend web experiences to architecting robust, scalable, and high-performance mobile applications.
              <br /><br />
              I'm passionate about clean code, fluid animations, and delivering pixel-perfect user interfaces that feel native and premium. Naturally curious and quietly confident, I am constantly exploring new technologies to build solutions that not only meet business needs but exceed user expectations.
              <br /><br />
              Let's build something exceptional together. Say hi to me on{" "}
              <a href="https://twitter.com/haywhyvilla" target="_blank" rel="noreferrer" className="twitter-link">@haywhyvilla</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
